export default "__VITE_ASSET__ZqHi43Oq__"